import { SKINCARE_TRACKER } from "../constants/url";
import { useAppDispatch } from "../hooks/reduxHooks";
import { catchErrors } from "../utils/catchErrors";
import { getApiCall, genericApiCall } from "../utils/servicesBaseUtil";
import { message } from "antd";

export const getSkincareTrackerApi = ({
  survey_id,
  finalCallback,
  successCallback,
  unAunthenticatedCallback,
}) => {
  return () => {
    let url = `${SKINCARE_TRACKER}?survey_id=${survey_id}`;

    getApiCall({ url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          if (unAunthenticatedCallback) {
            unAunthenticatedCallback();
          }
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};

export const saveSkincareTrackerApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = SKINCARE_TRACKER;

    genericApiCall({
      url: url,
      method: "POST",
      data: JSON.stringify(data),
      ContentType: "application/json",
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};
